import autocompleter from '../plugins/autocompleter'
import uploader from '../plugins/uploader'

document.addEventListener('turbolinks:load', function(){
  autocompleter.init()
  uploader.init()
});
